import {dataFetcher} from "../../services/dataGuetter/dataFetcher";


export function getFrontVersion():Promise<FrontVersion>{
    return dataFetcher(`front_versions/1`, {method:'get'})
}